import { categories } from "@/mocks/chiguaData";
import SectionHeading from "./SectionHeading";

export default function CategoryBrowse() {
  return (
    <section id="categories" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="分类瓜田"
          title="按主题翻，反转不重样"
          desc="职场、感情、邻里、家庭……每个分类都有自己的一套「打脸剧本」，挑一块瓜田扎进去吃。"
        />

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#library"
              className="group flex items-center gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-200 hover:bg-primary-50/50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-xl text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{c.name}</h3>
                <p className="text-xs text-foreground-500">{c.count} 条反转瓜</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}